import { useSelector } from 'react-redux';
import { getVisibleDialogs } from './index';

export const useGlobalDialogs = () => useSelector(getVisibleDialogs);
